<template>
    <main class="mt-5">
        <div class="card mt-3">
            <div class="card-header border-0">
                <h5 class="card-title font-bold py-3">آیتم های تکراری انبار</h5>
                <div style="flex: 1"></div>
            </div>
            <!-- <div class="row px-4 not-in-print">
                <div class="row col-12">
                    <b-form-group class="col-4">
                    <multiselect
                        placeholder="انتخاب انبار"
                        v-model="selectedStore"
                        open-direction="bottom"
                        :options="stores"
                        label="label"
                        track-by="id"
                        :searchable="true"
                        :close-on-select="true"
                        :show-labels="false"
                        :disabled="disabled"
                    >
                        <template slot="noOptions"> موردی یافت نشد </template>
                        <template slot="noResult"> موردی یافت نشد </template>
                    </multiselect>
                    </b-form-group>
                    <DatePickerRange class="col-md-6" v-model="filterDate" />
                </div>
                <b-button
                    class="col-md-2"
                    variant="primary"
                    @click="doFilter"
                    :disabled="disabled"
                    >فیلترسازی</b-button
                >
            </div> -->
            <div id="print" class="p-4">
                <b-table
                    v-if="reports"
                    bordered
                    :items="reports"
                    striped
                    :fields="fields"
                    responsive
                >
                </b-table>
            <div v-if="!reports" class="alert alert-primary">در حال بارگزاری</div>
            </div>
        </div>
    </main>
</template>
<script>
    import { BTable, BFormGroup, BFormInput, BButton, BTd, BFormCheckbox } from "bootstrap-vue";
    import configProvider from "@@/core/configProvider";
    import reportMixin from "@@/core/mixins/reportMixin";
    import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";
    import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
    import CustomerSearch from "@@/core/components/shared/CustomerSearch/CustomerSearch";
    export default {
        name: "duplicateStoreItems",
        components: {
            BTable,
            BFormGroup,
            BFormInput,
            ProductSearch,
            BButton,
            BTd,
            DatePickerRange,
            CustomerSearch,
            BFormCheckbox,
        },
        configProvider,
        data() {
            return {
                disabled: false,
                fields: [
                    {
                        key: "variety_id",
                        label: "شناسه تنوع ",
                    },
                    {
                        key: "variety_name",
                        label: "عنوان تنوع",
                    },
                    {
                        key: "store_name",
                        label: "نام انبار",
                    },
                    {
                        key: "balance1",
                        label: "تعداد 1",
                    },
                    {
                        key: "balance2",
                        label: "تعداد 2",
                    },
                ],
                page: 1,
                reports: null,
                sortBy: null,
                sortDesc: null,
                disabledRest: true,
            };
        },
        mixins: [reportMixin],
        mounted() {
            this.loadData();
        },
        methods: {
            resetFilter() {
                this.disabledRest = true;
                this.loadData();
            },
            doFilter() {
                this.loadData();
            },
            changePage(page = 1) {
                this.previousPage = this.page;
                this.page = page;
                this.loadData();
            },
            async loadData() {
                try {
                    this.disabled = true;
                    const response = await this.$axios.get("admin/reports/duplicate-store-items");
                    this.reports = response.data.data.duplicates;
                    console.log(this.reports);
                } catch (e) {
                    this.$root.notify(e);
                } finally {
                    this.disabled = false;
                }
            },
        },
    };
</script>